import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import { Key } from 'ts-key-enum';

interface CustomerSupportContactInfoProps {
    customerServiceLabel: string;
    customerServicePhoneNumber: string;
    customerServiceUrl: string;
    errorView?: boolean;
    linkKeyDownHandle?: (goFurther: boolean) => void;
    hideModal: () => void;
}

export const CustomerSupportContactInfo = ({
    customerServiceLabel,
    customerServicePhoneNumber,
    customerServiceUrl,
    errorView,
    linkKeyDownHandle,
    hideModal
}: CustomerSupportContactInfoProps) => {
    const linkRef = useRef<HTMLAnchorElement>(null);

    useEffect(() => {
        if (!linkRef.current || !linkKeyDownHandle) return;

        const handleOnKeyDown = (e: KeyboardEvent) => {
            if (e.key === Key.Escape) {
                hideModal();
            } else if (e.key === Key.Tab) {
                e.preventDefault();
                linkKeyDownHandle(!e.shiftKey);
            }
        };

        linkRef.current.addEventListener('keydown', handleOnKeyDown);

        return () => {
            linkRef.current?.removeEventListener('keydown', handleOnKeyDown);
        };
    }, []);

    return (
        <div className={classNames(errorView ? 'ErrorView__CustomerCenter' : 'PhilModal__CustomerCenter')}>
            <a className="RxMenu__QuickHelp__Link" href={customerServiceUrl} id="CustomerSupportContactInfo_Link" ref={linkRef}>
                <span className={`RxMenu__LinkIcon RxMenuIcon__Support`} />
                <div className="PhilModal__CustomerCenter--TextContainer">
                    <span className="RxMenu_Text">{customerServiceLabel}</span>
                    <span className="RxMenu_Text">{customerServicePhoneNumber}</span>
                </div>
            </a>
        </div>
    );
};
